<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Create Validation Code</p>
    </header>
    <section class="modal-card-body" style="min-width: 800px; max-height: 80vh; overflow-y: auto;">
      <app-loader [Parent]="Busyable"></app-loader>
      <app-field Label="Validation Code">
        <div class="control">
          @if (ValidationCode != null) {
            <input class="input" [value]="ValidationCode.Code" type="text" (change)="update('Code', $event)" placeholder="Enter the Validation code name">
          }
        </div>
      </app-field>
      <app-field Label="Maximum Uses">
        <div class="control">
          @if (ValidationCode != null) {
            <input class="input" min="1" step="1" [value]="ValidationCode.MaxUses" type="number" (change)="update('MaxUses', $event)" placeholder="maximum number of uses">
          }
        </div>
      </app-field>
      <app-field Label="Active Start Date">
        <div class="control">
          @if (ValidationCode != null) {
            <input class="input" [value]="ValidationCode.ActiveStartDateLocal | date:'yyyy-MM-ddTHH:mm'" (change)="update('ActiveStartDateLocal', $event)" type="datetime-local">
          }
        </div>
      </app-field>
      <app-field Label="Active End Date">
        <div class="control">
          @if (ValidationCode != null) {
            <input class="input" [value]="ValidationCode.ActiveEndDateLocal | date:'yyyy-MM-ddTHH:mm'" (change)="update('ActiveEndDateLocal', $event)" type="datetime-local">
          }
        </div>
      </app-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary" (click)="Save()">Save</button>
    </footer>
  </div>
</div>